import {
  TMemberService,
  TMemberServiceType,
} from '../../core/types/MemberService'
import { TSellFluxIntegration } from '../../core/types/SellFlux'

export const cademiDefault: TMemberService = {
  id: '',
  identifier: '',
  domain: '',
  apiKey: '',
  token: '',
  webhookCode: '',
  type: TMemberServiceType.Cademi,
}

export const memberKitDefault: TMemberService = {
  id: '',
  identifier: '',
  domain: '',
  apiKey: '',
  token: '',
  webhookCode: '',
  type: TMemberServiceType.MemberKit,
}

export const astronMembersDefault: TMemberService = {
  id: '',
  identifier: '',
  domain: '',
  apiKey: '',
  token: '',
  webhookCode: '',
  type: TMemberServiceType.AstronMembers,
}

export const theMembersDefault: TMemberService = {
  id: '',
  identifier: '',
  domain: '',
  apiKey: '',
  token: '',
  webhookCode: '',
  type: TMemberServiceType.TheMembers,
}

export const sellFluxDefault: TSellFluxIntegration = {
  codeId: '',
  identifier: '',
  url: '',
  isPurchaseCompleted: false,
  isCanceled: false,
  isRefunded: false,
  isDisputing: false,
  isAwaitingPayment: false,
  isAbandonedCart: false,
  tags: [],
  allProducts: true,
  productIds: [],
}
